import React, { useEffect } from "react";
import AppBody from "../components/AppBody";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  deleteTrainingSyllabus,
  getTrainingSyllabus,
  updateTrainingStatus,
} from "../../actions/learning_provider/training_syllabus_action";
import { setRecordingUrl } from "../../actions/learning_provider/training_action";
import { UI_URL } from "../../config/api";
const TrainingSyllabusList = () => {
  const state = useSelector((state) => state.trainingSyllabusReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { slug } = useParams();

  useEffect(() => {
    dispatch(getTrainingSyllabus({ slug: slug }));
  }, []);

  const startSession = (id) => {
    localStorage.setItem("trTopicId", id);
    window.open(UI_URL + "/training/start/" + btoa(id));
    dispatch(updateTrainingStatus({ id: id }));
    //navigate("/training/start/" + btoa(id));
  };

  const playRecording = (url) => {
    dispatch(setRecordingUrl(url));
    navigate("/recording");
  };

  const deleteSyllabusTopic = (id) => {
    dispatch(deleteTrainingSyllabus({ id: id }));
  };

  if (state.is_done) {    
    dispatch(getTrainingSyllabus({ slug: slug }));
  }

  const viewDetails = (id) => {
    navigate("/training-attendance/" + btoa(id));
  };

  console.log(state.loading);  

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0  shadow-xs p-0 mb-4">
            <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
              <Link to={"/all-trainings"} className="d-inline-block mt-2">
                <i className="ti-arrow-left font-sm text-white"></i>
              </Link>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                Training Topics
              </h4>
              <div className="col text-right pr-0">
                <Link to={"/add-training-syllabus/" + slug}>
                  <a
                    className="line-height-36 custom-icon mr-2"
                    title="Add Syllabus"
                  >
                    <i className="feather-plus-circle"></i>
                  </a>
                </Link>
              </div>
            </div>
            <div className="card-body  p-4 w-100 border-0 ">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Topic Name</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                      <th>No Of Min</th>
                      <th>Rating</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.list &&
                      state.list.map((li, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{li.session_topic}</td>
                          <td>{li.start_time ? li.start_time : "-"}</td>
                          <td>{li.end_time ? li.end_time : "-"}</td>
                          <td>{li.no_of_min ? li.no_of_min : "-"}</td>
                          <td>{li.rating ? li.rating : "-"}</td>
                          <td>
                            {li.status === 1
                              ? "Starting"
                              : li.status === 2
                              ? "Completed"
                              : "Schedule"}
                          </td>
                          <td>
                            <a
                              className="line-height-36 custom-icon mr-2"
                              title="Start Session"
                              target="_blank"
                              onClick={() => startSession(li.id)}
                            >
                              <i className="feather-play"></i>
                            </a>

                            <a
                              className="line-height-36 custom-icon mr-2"
                              title="View Attendance"
                              target="_blank"
                              onClick={() => viewDetails(li.id)}
                            >
                              <i className="feather-eye"></i>
                            </a>
                            {li.recording_url && (
                              <a
                                className="line-height-36 custom-icon mr-2"
                                title="Play Recording"
                                target="_blank"
                                onClick={() => playRecording(li.recording_url)}
                              >
                                <i className="fa-solid fa-record-vinyl"></i>
                              </a>
                            )}

                            <a
                              className="line-height-36 custom-icon mr-2"
                              title="Delete Topic"
                              target="_blank"
                              onClick={() => deleteSyllabusTopic(li.id)}
                            >
                              <i className="feather-trash"></i>
                            </a>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default TrainingSyllabusList;
